import { useEffect, useState } from 'react';
import {
  Center,
  Box,
  Title,
  Button,
  Table,
  Group,
  Image,
  Text,
  Stack,
  Container,
  Paper,
  Divider,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom';
import QRCode from 'qrcode.react';
import dayjs from 'dayjs';
import { sendRequest, sendRequestWithToken } from '../../services/services';
import Logo from '../../image/mouqfi.png';
import tickMark from '../../image/tick-mark.svg';
import PrintInvoice from '../../image/print-invoice.svg';
import FindMyCar from '../../image/find-my-car.svg';
import PrimaryButton from '../../components/GroupButton';

const PaymentStatus = ({ invoiceDataId, passDataId }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [ticketData, setTicketData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [, setInvoiceId] = useState();

  const [, setMounted] = useState(false);
  const [, setLocation] = useState('');
  const [parentSiteData, setParentSiteData] = useState({});
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const Pass = parseInt(invoiceDataId, 10);
  const passIdData = passDataId;

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  useEffect(() => {
    sendRequestWithToken(`payments/invoice/${Pass}`, 'get').then((res) => {
      setInvoiceData(res?.data);
      setInvoiceId(res);
    });
  }, [Pass]);

  const invoicePrint = () => {
    window.print();
    localStorage.removeItem('selectedVas');
    navigate('/');
    window.location.reload();
  };

  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${passIdData}`, 'get').then((res) => {
      setTicketData(res?.data || []);
    });
  }, [passIdData]);

  const now = dayjs();

  const rows = invoiceData?.invoice_items.map((element) => (
    <tr key={element.name}>
      <td>{(Number(element?.amount) + (Number(element?.amount) * Number(15)) / 100).toFixed(2)}</td>
      <td>{((Number(element?.amount) * Number(15)) / 100).toFixed(2)}</td>
      <td>{Number(element?.unit_price).toFixed(2)}</td>
      <td>{element?.unit}</td>
      <td>
        {element.invoice_item_list?.name === 'Reservation'
          ? 'Parking'
          : element.invoice_item_list?.name}
      </td>
    </tr>
  ));

  const enfoRows = ticketData?.enforcements?.map((em) => (
    <tr key={em?.name}>
      <td>{em?.name}</td>
      <td>{Number(em?.amount).toFixed(2)}</td>
      <td>{em ? 1 : 0}</td>
      <td>
        {Number(em?.amount).toFixed(2)} {t('ticket.amount.sar.text')}
      </td>
    </tr>
  ));

  useEffect(() => {
    sendRequest(`sites/parent-site/${ticketData?.result?.sites?.p_id}`, 'get').then((res) => {
      setParentSiteData(res?.data);
    });
  }, [ticketData?.result?.sites?.p_id]);
  return (
    <>
      <Box style={{ height: 'calc(100vh - 24px)', marginTop: '24px' }} className="no-printme">
        <Stack justify="space-between" style={{ height: '100%' }}>
          <Box>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
              }}
            >
              <div style={{ opacity: '0.6', pointerEvents: 'none' }}>
                <PrimaryButton />
              </div>
            </Container>
          </Box>

          <Box style={{ flexGrow: '1' }}>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <Box
                className="no-printme"
                style={{
                  height: 'fit-content',
                  marginBottom: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: '1',
                  justifyContent: 'space-between',
                }}
              >
                <Stack>
                  <Title style={{ color: '#2C5864', margin: '1% 0' }} order={3}>
                    {t('payment.pay.for.ticket')} #{searchParams.get('passId')}
                  </Title>
                </Stack>
                <Paper shadow="sm" p="lg" radius="lg" style={{ flex: '1' }}>
                  <QRCode
                    style={{ position: 'absolute', height: '90px', width: '90px' }}
                    value={JSON.stringify({
                      ticket_Number: passIdData,
                      invoice_Number: invoiceData?.id,
                      vat_Number: parentSiteData?.vat_no,
                    })}
                    renderAs="canvas"
                  />
                  <Group style={{ width: '100%', height: '100%' }} grow>
                    <Stack justify="space-between" style={{ width: '100%', height: '100%' }}>
                      <Center style={{ marginTop: '3%' }}>
                        <Image src={tickMark} width="180px" />
                      </Center>
                      <Center>
                        <Title
                          style={{ color: '#2C5864', margin: '2% 0', textAlign: 'center' }}
                          order={3}
                        >
                          {t('payment.status.invoice.payment.success')}
                        </Title>
                      </Center>
                      <Group style={{ width: '100%' }} grow>
                        <Button
                          variant="filled"
                          color="teal"
                          radius="lg"
                          onClick={invoicePrint}
                          leftIcon={<Image src={PrintInvoice} height={36} />}
                          fullWidth
                          size="xl"
                          style={{ marginTop: '14px', backgroundColor: '#2C5864', height: '72px' }}
                        >
                          <Title order={3}>
                            {t('payment.status.invoice.print.invoice.button.text')}
                          </Title>
                        </Button>
                        <Button
                          variant="filled"
                          color="teal"
                          radius="lg"
                          onClick={() =>
                            navigate({
                              pathname: '/findmycarstation/findmycar',
                              search: createSearchParams({
                                passId: passIdData,
                              }).toString(),
                            })
                          }
                          leftIcon={<Image src={FindMyCar} height={36} />}
                          fullWidth
                          size="xl"
                          style={{ marginTop: '14px', backgroundColor: '#50A847', height: '72px' }}
                        >
                          <Title order={3}>{t('find.my.car.title.text')}</Title>
                        </Button>
                      </Group>
                    </Stack>
                  </Group>
                </Paper>
              </Box>
            </Container>
          </Box>
        </Stack>
      </Box>
      <Box>
        <div className="printme" style={{ marginTop: '-460px' }}>
          <Stack align="center" spacing={0}>
            <Image src={Logo} width={200} py="md" />
            <Group position="apart">
              <Text>{now.format('DD/MM/YY')}</Text>
              <Text>{now.format('hh:mma')}</Text>
            </Group>
            <Text>{ticketData?.sites?.name}</Text>
            <Text>{ticketData?.sites?.name}</Text>
            <Text>**********************************</Text>

            <Title order={5}>فاتورة ضريبية مبسطة</Title>
            <Title order={5}>Simplified Tax Invoice</Title>
            <Group>
              <Text>{t('payment.status.invoice.print.vat.number.text')}</Text>
              <Text>{parentSiteData?.vat_no}</Text>
            </Group>
            <Text>*******************************************</Text>
          </Stack>
          <Stack>
            <Group>
              <Text>{t('payment.status.invoice.invoice.number')}</Text>
              <Text>{invoiceData?.id}</Text>
            </Group>
            <Group>
              <Text>{t('payment.status.invoice.payment.type')}</Text>
              <Text>{invoiceData?.payment_transactions?.[0]?.payment_types?.name}</Text>
            </Group>
          </Stack>
          <Divider my="sm" size="md" color="#0000000" variant="dashed" />

          <Box>
            <Center>
              <Table>
                <thead>
                  <tr>
                    <th>
                      <Text weight={700} size="sm">
                        القيمة
                      </Text>
                    </th>
                    <th>
                      <Text weight={700} size="sm">
                        الضريبة
                      </Text>
                    </th>
                    <th>
                      <Text weight={700} size="sm">
                        تكلفة الوحدة
                      </Text>
                    </th>
                    <th>
                      <Text weight={700} size="sm">
                        الكمية
                      </Text>
                    </th>
                    <th>
                      <Text weight={700} size="sm">
                        التفاصيل
                      </Text>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rows} {enfoRows}
                </tbody>
              </Table>
            </Center>
            <Divider my="sm" size="md" color="#0000000" variant="dashed" />

            <Group position="apart">
              <Stack>
                <Text size="md" weight={500}>
                  {Number(invoiceData?.total_amount).toFixed(2)}
                </Text>
                <Text size="md" weight={500}>
                  {Number(invoiceData?.tax).toFixed(2)}
                </Text>
                <Text size="md" weight={500}>
                  {Number(invoiceData?.paid_amount).toFixed(2)}
                </Text>
              </Stack>

              <Stack>
                <Text size="md" weight={700}>
                  المجموع الفرعي
                </Text>
                <Text size="md" weight={700}>
                  الضريبة ( 15% )
                </Text>
                <Text size="md" weight={700}>
                  الإجمالي
                </Text>
              </Stack>
            </Group>
          </Box>
          <Divider my="sm" size="md" color="#0000000" variant="dashed" />
          <Divider
            my="sm"
            size="md"
            label={t('payment.status.invoice.print.invoice.qr.divider.label')}
            labelPosition="center"
            variant="dashed"
          />

          <Center py="xl">
            <QRCode
              value={JSON.stringify({
                ticket_Number: passIdData,
                invoice_Number: invoiceData?.id,
                vat_Number: parentSiteData?.vat_no,
              })}
              renderAs="canvas"
            />
          </Center>
          <Center>
            <Text>powered by Mawqfi</Text>
          </Center>
          <Divider
            my="sm"
            size="md"
            label={t('payment.status.invoice.print.invoice.qr.divider.label')}
            labelPosition="center"
            variant="dashed"
          />
        </div>
      </Box>
    </>
  );
};
export default PaymentStatus;
